// Copyright 2026, University of Maryland, All Rights Reserved
import type { KbSchema } from '../types'

/**
 * Render `KnowledgeBaseItem.fields` into a single `content` string. This is
 * stored alongside the structured fields for backward-compatibility with KB
 * consumers that still read `content` (e.g., search). The format mirrors the
 * "Title (parenthetical)\n\nLABEL: value\nLABEL: value" pattern.
 *
 * `title` (if present) becomes the first line. All other field values are
 * prefixed with their uppercased label.
 */
export function renderContentFromFields(
  schema: KbSchema,
  values: Record<string, string>,
): string {
  const lines: string[] = []
  const titleField = schema.fields.find(f => f.key === 'title')
  if (titleField) {
    const titleValue = (values.title ?? '').trim()
    if (titleValue) {
      lines.push(titleValue)
      lines.push('')
    }
  }
  for (const field of schema.fields) {
    if (field.key === 'title') continue
    const value = (values[field.key] ?? '').trim()
    if (!value) continue
    lines.push(`${field.label.toUpperCase()}: ${value}`)
  }
  return lines.join('\n').trim()
}
